import { createStore, compose, applyMiddleware } from 'redux';
import rootReducer from './root-reducer';
import middleware from './middleware';

const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
let composedMiddleware;
if (devTools) {
  composedMiddleware = compose(applyMiddleware(...middleware), devTools);
} else {
  composedMiddleware = compose(applyMiddleware(...middleware));
}

const configureStore = (initialState) => {
  const store = createStore(rootReducer, initialState, composedMiddleware);

  if (module.hot) {
    module.hot.accept('./root-reducer', () => {
      console.log('swapping reducer....');
      const nextRootReducer = require('./root-reducer');
      store.replaceReducer(nextRootReducer.default);
    })
  }

  return store;
}

export default configureStore;
